import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { VERIFY_OTP_INVESTOR_SUCCESS } from '../types/onBoarding';
import { REDIRECT_KYC_UPDATE_SUCCESS } from '../../digilocker/redux/types/digilocker';

const initState: Partial<{ token: string | null }> = {
  token: null,
};
function investorReducer(state = initState, action: AnyAction): Partial<{ token: string | null }> {
  switch (action.type) {
    case VERIFY_OTP_INVESTOR_SUCCESS: {
      console.log('investor', action.body);
      return {
        ...state,
        ...action.body,
      };
    }
    case REDIRECT_KYC_UPDATE_SUCCESS: {
      const tokenObj = { token: action.tokenObj.token };
      return {
        ...state,
        ...tokenObj,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default investorReducer;
